<template>
  <div class="text-input-value">
    <div v-if="!editing">
      {{ edited_value }}
      <a v-show="!disabled" style="font-size: 0.5em; margin-left: 0.8em; width: 6em" @click.prevent="edit_value"
        ><font-awesome-icon icon="pen" /> Edit</a
      >
    </div>
    <div v-else style="display: flex; align-items: baseline">
      <input
        ref="valueInput"
        v-model="edited_value"
        type="text"
        class="form-control"
        :placeholder="placeholder"
        @change="emit('change', edited_value)"
        style="font-size: inherit; color: inherit; height: 3.5rem"
      />
      <a style="font-size: 0.5em; margin-left: 0.8em; width: 6em" @click.prevent="update_value"
        ><font-awesome-icon icon="pen" /> Save</a
      >
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch, onMounted, nextTick } from "vue";
const editing = ref(false),
  edited_value = ref(""),
  valueInput = ref<null | { focus: () => null }>(null);
interface Props {
  text_value: string | any;
  placeholder?: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), { placeholder: "" });

const emit = defineEmits(["update", "change"]);

const update_value = function () {
  editing.value = false;
  emit("update", edited_value.value);
};

const edit_value = function () {
  editing.value = true;
  nextTick(() => valueInput.value?.focus());
};

watch(
  () => props.text_value,
  () => {
    edited_value.value = props.text_value;
  }
);

onMounted(() => {
  edited_value.value = props.text_value;
});
</script>
<style scoped>
.text-input-value {
  font-weight: 500;
  font-size: 1.7em;
}
</style>
